<template>
  <c-list
    :data="list.items"
    :columns="cList.columns"
    :total="list.total"
    :page-current="listPageCurrent"
    :search-where="listSearchWhere"
    @selection-change="handleListSelectionChange"
  >
    <c-list-header>
      <c-list-operations>
        <c-bulk-delete :selected-items="listSelectedItems" @ok="confirmDelete">
        </c-bulk-delete>
      </c-list-operations>
      <c-list-search>
        <Form
          class="c-form c-form--search"
          inline
          @submit.native.prevent="search"
        >
          <Form-item prop="status">
            <Select
              class="c-form__input"
              placeholder="请选择状态"
              clearable
              v-model="cList.cSearch.where.status.$eq"
            >
              <Option
                v-for="item in dicts.CheckStatus"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              >
                {{ item.label }}
              </Option>
            </Select>
          </Form-item>
          <Form-item prop="tjopen">
            <Select
              class="c-form__input"
              placeholder="推荐校区"
              clearable
              v-model="cList.cSearch.where.tjopen.$eq"
            >
              <Option
                v-for="item in dicts.EnableStatus"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              >
                {{ item.label }}
              </Option>
            </Select>
          </Form-item>
          <Form-item prop="name">
            <Input
              class="c-form__input"
              placeholder="请输入名称"
              v-model="cList.cSearch.where.name.$like"
            />
          </Form-item>
          <Form-item>
            <Button type="primary" @click="search">
              查询
            </Button>
          </Form-item>
        </Form>
      </c-list-search>
    </c-list-header>
  </c-list>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import ListMixin from "view-ui-admin/src/mixins/list";

const module = "schools";
const initWhere = {
  status: {
    $eq: ""
  },
  tjopen:{
    $eq: ""
  },
  name: {
    $like: ""
  }
};

@Component({
  mixins: [RouteParamsMixin, ListMixin],
  computed: mapState({
    list: state => state[module].list
  })
})
export default class extends Vue {
  data() {
    return {
      cList: {
        columns: [
          {
            type: "selection",
            width: 60
          },
          {
            title: "名称",
            key: "name",
            width: 100
          },
          {
            title: "地址",
            key: "address",
            width: 300
          },
          {
            title: "负责人",
            key: "leader",
            width: 100
          },
          {
            title: "手机号",
            key: "phoneNumber",
            width: 130
          },
          {
            title: "状态",
            width: 100,
            render: (h, { row }) =>
              h(
                "span",
                null,
                this.$helpers.getItem(
                  this.dicts.CheckStatus,
                  "value",
                  row.status
                )["label"]
              )
          },
          {
            title: "推荐校区",
            width: 50,
            render: (h, { row }) =>
              h(
                "span",
                null,
                this.$helpers.getItem(
                  this.dicts.EnableStatus,
                  "value",
                  row.tjopen
                )["label"]
              )
          },
          {
            title: "美术馆表单",
            width: 50,
            render: (h, { row }) =>
              h(
                "span",
                null,
                this.$helpers.getItem(
                  this.dicts.EnableStatus,
                  "value",
                  row.msgopen
                )["label"]
              )
          },
          {
            title: "操作",
            key: "action",
            width: 300,
            render: (h, { row }) =>
              h("div", [
                h("c-dropdown", {
                  props: {
                    width: 66,
                    title: "审核",
                    options: this.dicts.CheckStatus
                  },
                  on: {
                    click: action => {
                      this.changeStatus(row.id, action);
                    }
                  }
                }),
                h("c-dropdown", {
                  props: {
                    width: 66,
                    title: "推荐",
                    options: this.dicts.EnableStatus
                  },
                  on: {
                    click: action => {
                      this.changeTjopen(row.id, action);
                    }
                  }
                }),
                h("c-dropdown", {
                  props: {
                    width: 100,
                    title: "美术馆表单",
                    options: this.dicts.EnableStatus
                  },
                  on: {
                    click: action => {
                      this.changeMsgopen(row.id, action);
                    }
                  }
                }),
                h(
                  "Button",
                  {
                    props: {
                      to: `/${this.alias}/schools/list/form/${row.id}`
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    on: {
                      click: () => {
                        this.accountLogin(row);
                      }
                    }
                  },
                  "后台"
                ),
                h("c-confirm-button", {
                  props: {
                    buttonText: "删除",
                    confirmText: "确认删除？"
                  },
                  on: {
                    ok: () => {
                      this.confirmDelete(row.id);
                    }
                  }
                })
              ])
          }
        ],
        cSearch: {
          where: this.$helpers.deepCopy(initWhere)
        }
      }
    };
  }

  async beforeRouteUpdate(to, from, next) {
    this.initListSearchWhere(initWhere);
    this.getList();
    next();
  }

  async created() {
    this.initListSearchWhere(initWhere);
    this.getList();
  }

  getList() {
    return this.$store.dispatch(`${module}/getList`, {
      query: {
        offset: (this.listPageCurrent - 1) * this.$consts.PageSize,
        limit: this.$consts.PageSize,
        where: this.listSearchWhere || initWhere
      }
    });
  }

  async confirmDelete(ids) {
    await this.$store.dispatch(`${module}/delete`, { id: ids });
    this.$Message.success("删除成功");

    const { items } = await this.getList();
    !items.length && this.goListPrevPage();
  }

  async changeStatus(id, action) {
    await this.$store.dispatch(`${module}/put`, {
      id,
      body: {
        status: action
      }
    });
    this.$Message.success("修改状态成功");
    this.getList();
  }

  async changeTjopen(id, action) {
    await this.$store.dispatch(`${module}/put`, {
      id,
      body: {
        tjopen: action
      }
    });
    this.$Message.success("修改推荐成功");
    this.getList();
  }

   async changeMsgopen(id, action) {
    await this.$store.dispatch(`${module}/put`, {
      id,
      body: {
        msgopen: action
      }
    });
    this.$Message.success("修改推荐成功");
    this.getList();
  }

  async accountLogin({ phoneNumber }) {
    const {
      data: { manager, token }
    } = await this.$store.dispatch("schools/postAction", {
      action: "accountLogin",
      body: { phoneNumber }
    });

    this.$auth.login({
      schoolId: manager.school.id,
      user: manager,
      token: token
    });

    window.open(`/?schoolId=${manager.school.id}#/`);
  }
}
</script>
